import React from 'react';
import styled from 'styled-components';
import { withStyles } from 'material-ui/styles';
import { SupportLink } from './NotFound';

const Page = styled.a`
& span:hover {
    text-decoration: underline;
}`

const AccessDenied = ({ classes }) => (
<Page>
    <div>
        <div className={classes.root}> {'Our apologies, but you do not have access to this data.'} </div>
        <div className={classes.listHeader}> {'Possible reasons may include:'} </div>
        <li className={classes.list1}> {'There are currently no Gap Packet Notifications associated with the email account you used to login.'}</li>
        <ul className={classes.listHeader}><li className={classes.list3}>{'Gap Packet Notifications are only accessible using the email entered in CTMS. Please ensure this is the email you use to login.'}</li></ul> 
        <li className={classes.list2}> {'There are no Gap Packet Notifications that have been distributed to you yet.'} </li>
        <ul className={classes.listHeader}><li className={classes.list3}>{'The distribution of Gap Packet Notifications is conducted by study team personnel. Please reach out to your study team representative to inquire about which roles receive Gap Packet Notifications.'}</li></ul>
        <div className={classes.lastDiv}> {'If you think you\'ve encountered this page in error, please contact'} </div>
        <SupportLink />
        <b style={{fontWeight: 'bold', fontSize: '38px'}}> {'or your study team for assistance.'} </b>
    </div>
    </Page>
);

const styles = (theme) => ({
    rootDiv: {
        textAlight: 'center',
        position: 'absolute',
        width:'77em',
        left: '55%',
        top: '40%',
        transform: 'translate(-50%, -50%)',
        marginBottom: '25px'
    },
    root: {
        fontWeight: 'bold',
        fontSize: '36px',
        marginBottom: '25px'
    },
    lastDiv: {
        fontWeight: 'bold',
        fontSize: '38px'
    },
    list1: {
        fontSize: '28px'
    },
    list2: {
        fontSize: '28px',
        marginBottom: '25px'
    },
    list3: {
        fontSize: '28px',
        marginLeft: '40px',
        listStyleType: 'circle'
    },
    listHeader: {
        fontSize: '28px',
        marginBottom: '25px'
    }

})

export default withStyles(styles)(AccessDenied);